import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormInput from './Generic/FormInput';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import LoadingOverlay from './Generic/LoadingOverlay';
import { useSetMenu } from "../hooks/useSetMenu";
import { useStore } from '../stores/store';
const Help = () => {
    const { t } = useTranslation();
    const axiosPrivate = useAxiosPrivate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { mainStore } = useStore();
    useSetMenu(mainStore.HelpMenuType, mainStore.HelpMenuNo);

    const { register, reset, formState: { errors } } = useForm();



    return (
        <div className="col-lg-12 mb-lg-0 mb-4">
            <div className="card rounded-0 borderLine">
                <div className="card-header pb-0 rounded-0 bg-danger cardHeaderBackground">
                    <p className="crudTitle">{t('profileHelp')}</p>

                </div>
                <div className="card-body p-3">
                    <p>
                        This Help page will display information about our system and provide guidance on how to use it. You'll find basic instructions and helpful tips to assist you with navigating the system.
                        In the future, we plan to add more detailed information and additional resources here. Stay tuned for updates that will further enhance your experience and help you get the most out of our system.
                    </p>

                </div>
            </div>
        </div>
    );
};

export default Help;
